export const ExperimentsConsts = {
  EditorOOIFormPage: 'specs.bookings.EditorOOIFormPage',
  FormEditorKBContent: 'specs.bookings.FormEditorKBContent',
  MultiLocationUoU: 'specs.bookings.MultiLocationUoU',
  AddonsWithPlanOnlyUOU: 'specs.bookings.AddonsAndPlanOnlyUOU',
  CartConflictEnableSlotsTimezoneConversion:
    'specs.bookings.CartConflictEnableSlotsTimezoneConversion',
  UOUIntakeFormsIntegration: 'specs.bookings.UOUIntakeFormsIntegration',
  ShowRemainingCourseSessions: 'specs.bookings.ShowRemainingCourseSessions',
  ShowUnavailableSlotForm: 'specs.bookings.ShowUnavailableSlotForm',
  ShowErrorMessageOnInvalidIntakeForm:
    'specs.bookings.showErrorMessageOnInvalidIntakeForm',
  TimezoneAwareSlotMatching: 'specs.bookings.TimezoneAwareSlotMatching',
  DepositeOrFullAmountUoU: 'specs.bookings.DepositeOrFullAmountUoU',
  AllDayMultiDayEvents: 'specs.bookings.AllDayMultiDayEvents',
  SubscriptionPricingUoU: 'specs.bookings.SubscriptionPricingUoU',
  AllowMonthlyPricingAutomaticDiscounts:
    'allowMonthlyPricingAutomaticDiscountsBO',
  RelatedProductsOnServices: 'specs.bookings.relatedProductsOnServices',
  AllowMonthlyPricingProductAddOns: 'allowMonthlyPricingProductAddOns',
  MultiCurrencyInBookingsUoU: 'multiCurrencyInBookingsUoU',
  MigrateBookingsThumbnailToWds: 'migrateBookingsThumbnailToWDS',
  BookingsUseEcomCartV2: 'bookingsUseEcomCartV2',
  CartV2BusinessLocation: 'bookingsCartV2BusinessLocation',
  CourseBusinessLocation: 'bookingsCourseBusinessLocation',
  FormBfcacheStatusReset: 'formBfcacheStatus',
  PlanAndBook: 'bookingsPlanAndBook',
  PricingPlansMultiplePricingVariants:
    'pricingPlansMultiplePricingVariantsViewer',
  BookForSomeoneElse: 'bookForSomeoneElseUou',
  BookingFormLoginBar: 'bookingFormLoginBarUou',
  CollectParticipantForm: 'collectParticipantFormUou',
  ShowSlotMoreDetailsOnMobile: 'showSlotMoreDetailsOnMobile',
  AddOnsWithImages: 'addOnsWithImages',
  PlanDefaultForVariantServicesUou: 'planDefaultForVariantServicesUou',
  ExpressCheckoutInBookingForm: 'expressCheckoutInBookingForm',
  PricingPlanRefundPolicy: 'pricingPlanRefundPolicyUoU',
};
